<div class="permissions-tree-container" tabindex="0">
  <p-tree [value]="tree" selectionMode="checkbox" [(selection)]="selectedNodes" (onNodeSelect)="onNodeSelect()"
    (onNodeUnselect)="onNodeUnselect()">
  </p-tree>
</div>